export type ScoreZone = 'green' | 'yellow' | 'red'

/**
 * Цветовая зона score по настраиваемым порогам (E2):
 *   score < yellow        → 'green'  (норма)
 *   yellow <= score < red → 'yellow' (подозрительно)
 *   score >= red          → 'red'    (плохо)
 */
export function scoreZone(score: number, yellow: number, red: number): ScoreZone {
  if (score >= red) return 'red'
  if (score >= yellow) return 'yellow'
  return 'green'
}
